var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, Grid, Typography, } from "@mui/material";
import useLoading from "../../hooks/Loading";
import { useWebgate } from "@xvia/webgate-connect";
import React, { useEffect, useState } from "react";
import CartilhasService from "../../services/api/CartilhasService";
import * as Muicon from "@mui/icons-material";
import { darken } from "@mui/material/styles";
import Endereco from "../Endereco";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import remarkGfm from "remark-gfm";
import EvaluationButton from "../EvaluationButton";
import { useHistory } from "react-router-dom";
export default function CartilhaPage(_a) {
    var _this = this;
    var sigla = _a.sigla, id = _a.id;
    var portalConnect = useWebgate().portalConnect;
    var _b = useState({}), cartilha = _b[0], setCartilha = _b[1];
    var _c = useState(2), margin = _c[0], setMargin = _c[1];
    var history = useHistory();
    var sort = function (a, b) { return a.id - b.id; };
    var hasCartilha = Object.values(cartilha).length !== 0;
    var handleBotaoVoltar = function () {
        history.goBack();
    };
    var service = new CartilhasService();
    var loading = useLoading();
    var fetchCartilhas = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, _i, _a, local, loc, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, 8, 9]);
                    loading.show();
                    return [4 /*yield*/, service.findByIdAndOrgao(id, sigla)];
                case 1:
                    response = _b.sent();
                    if (!response) return [3 /*break*/, 6];
                    _i = 0, _a = response[0].locais;
                    _b.label = 2;
                case 2:
                    if (!(_i < _a.length)) return [3 /*break*/, 5];
                    local = _a[_i];
                    if (!((local.latitude || 0) === 0 && (local.longitude || 0) === 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, service.getGeocodeFromAddress(local.endereco)];
                case 3:
                    loc = _b.sent();
                    local.latitude =
                        loc && typeof loc.lat === "string" && loc.lat !== ""
                            ? new Number(loc.lat).valueOf()
                            : 0;
                    local.longitude =
                        loc && typeof loc.lon === "string" && loc.lon !== ""
                            ? new Number(loc.lon).valueOf()
                            : 0;
                    _b.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5:
                    setCartilha(response[0]);
                    _b.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    error_1 = _b.sent();
                    console.log(error_1);
                    return [3 /*break*/, 9];
                case 8:
                    loading.hide();
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchCartilhas();
    }, []);
    useEffect(function () {
        setMargin((portalConnect === null || portalConnect === void 0 ? void 0 : portalConnect.isRunningInWebview()) ? 0 : 2);
    }, [portalConnect]);
    return (_jsx(Box, __assign({ id: "container-index b2", sx: { ml: margin, mr: margin } }, { children: (hasCartilha && (_jsxs(Card, __assign({ variant: "outlined", sx: { padding: margin, ml: 0, mr: 0 } }, { children: [_jsxs(Box, __assign({ component: "section", sx: function (theme) {
                        return {
                            background: "linear-gradient(45deg, ".concat(cartilha.gradienteInicio, " 0%, ").concat(darken(cartilha.gradienteFim || "rgb(0,0,0)", 0.3), " 100%)"),
                            p: 4,
                            borderTopRightRadius: theme.spacing(6),
                            borderBottomLeftRadius: theme.spacing(6),
                        };
                    } }, { children: [_jsx(Typography, __assign({ variant: "h1", sx: {
                                fontSize: "1.375rem",
                                fontWeight: 700,
                                letterSpacing: "-0.025em",
                                color: "white",
                            } }, { children: cartilha.tituloDestaque })), _jsx(Typography, __assign({ variant: "body1", sx: { mt: 1, color: "white", opacity: 0.95 } }, { children: _jsx(ReactMarkdown, __assign({ rehypePlugins: [rehypeHighlight], remarkPlugins: [remarkGfm] }, { children: cartilha.mensagemDestaque })) })), _jsx(Box, __assign({ sx: {
                                borderRadius: 6,
                                borderTopRightRadius: 0,
                                backgroundColor: "white",
                                width: "fit-content",
                                px: 3,
                                py: 1.5,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                ml: "auto",
                                mt: 2,
                            } }, { children: _jsx(Typography, __assign({ sx: { lineHeight: 1, fontWeight: 600 } }, { children: cartilha.tituloCurto })) }))] })), _jsxs(Box, __assign({ component: "section" }, { children: [_jsx(Typography, { variant: "h2", sx: {
                                fontSize: "1.125rem",
                                fontWeight: 600,
                                letterSpacing: "-0.025em",
                                mb: 2,
                            } }), (cartilha.mensagens || []).sort(sort).map(function (msg) {
                            return (_jsxs(Accordion, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(Muicon.ExpandMore, {}), "aria-controls": "panel1a-content", id: "panel1a-header" }, { children: _jsx(Typography, __assign({ variant: "caption", sx: { fontSize: "1rem", fontWeight: 600 } }, { children: _jsx(ReactMarkdown, __assign({ rehypePlugins: [rehypeHighlight], remarkPlugins: [remarkGfm] }, { children: msg.titulo })) })) })), _jsx(AccordionDetails, { children: _jsx(ReactMarkdown, __assign({ rehypePlugins: [rehypeHighlight], remarkPlugins: [remarkGfm] }, { children: msg.mensagem })) })] }));
                        })] })), _jsxs(Box, __assign({ component: "section" }, { children: [_jsx(Typography, __assign({ variant: "h2", sx: {
                                fontSize: "1.125rem",
                                fontWeight: 600,
                                letterSpacing: "-0.025em",
                                mb: 2,
                            } }, { children: cartilha.tituloRodape })), _jsx(Grid, __assign({ container: true, spacing: 3 }, { children: (cartilha.locais || []).map(function (local) {
                                var link = "https://www.google.com/maps/place/".concat(local.endereco);
                                if (local.latitude !== 0 || local.longitude !== 0) {
                                    link = "https://maps.google.com/?q=".concat(local.latitude, ",").concat(local.longitude);
                                }
                                return (_jsx(Grid, __assign({ item: true, md: 6, lg: 3, xs: 12, sm: 6 }, { children: _jsxs(Endereco, __assign({ mapLink: link }, { children: [_jsx(Box, __assign({ sx: {
                                                    overflow: "hidden",
                                                    borderRadius: 1,
                                                    width: "100%",
                                                    height: 200,
                                                    mb: 2,
                                                } }, { children: _jsxs(MapContainer, __assign({ center: [local.latitude || 0, local.longitude || 0], scrollWheelZoom: false, zoomControl: false, dragging: false, doubleClickZoom: false, zoom: 16, className: "map" }, { children: [_jsx(TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }), _jsx(Marker, { position: [
                                                                local.latitude || 0,
                                                                local.longitude || 0,
                                                            ] })] })) })), _jsx(Typography, __assign({ sx: { width: "100%", fontWeight: 600 } }, { children: local.titulo })), _jsx(Typography, __assign({ sx: { width: "100%" } }, { children: local.endereco })), _jsx(Typography, __assign({ sx: { width: "100%" } }, { children: local.contato }))] })) })));
                            }) }))] })), process.env.AVALIACAO_ID_PESQUISA && (_jsx(EvaluationButton, { idService: process.env.AVALIACAO_ID_PESQUISA, sigla: sigla }))] })))) || (_jsxs(_Fragment, { children: [_jsx(Typography, { children: "Cartilha n\u00E3o encontrada" }), _jsx(Button, __assign({ variant: "contained", onClick: handleBotaoVoltar }, { children: "Voltar" }))] })) })));
}
